import { usersRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { HourlyRateJson } from '../types';

export const useUpdateUserRate = () =>
  useMutation<ApiResponse<unknown>, unknown, HourlyRateJson>((hourRate) =>
    usersRepo.updateUserRate(hourRate),
  );
